<nav class="breadcrumb-container" [attr.aria-labelledby]="'breadcrumbTitleId'">
    <span hSrOnlyNoSnippet id="breadcrumbTitleId" role="heading" aria-level="2">{{ breadcrumbTitle }}</span>
    <ol class="breadcrumb">
        @for (breadcrumbSection of breadcrumbSectionsDisplayed; track breadcrumbSection; let isLast = $last) {
        <li class="paragraph-xsmall">
            @if (breadcrumbSection.url && !breadcrumbSection.unclickable) {

            <a
                [attr.href]="breadcrumbSection.url"
                (click)="sendClickEvent($event, breadcrumbSection)"
                [innerHTML]="breadcrumbSection.value">
            </a>

            } @else {

            <span
                class="unclickable"
                [attr.aria-current]="isLast ? 'page' : undefined"
                [innerHTML]="breadcrumbSection.value"></span>

            }
        </li>
        }
    </ol>
</nav>
